export default "__VITE_ASSET__BomW_dTF__"